import { useEffect, useRef, useState } from 'react';

/**
 * 모달이 열린 시점(openKey 변경 후 초기화 렌더)의 sig 를 스냅샷으로 잡고, 현재 sig 와 다르면 true.
 * openKey 가 null/'' 이면 닫힘으로 보고 false.
 */
export function useDirtySinceOpen(openKey: string | null | undefined, sig: string): boolean {
  const ref = useRef<{ key: string | null | undefined; sig: string | null; armed: boolean }>({
    key: undefined,
    sig: null,
    armed: false,
  });
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const r = ref.current;
    if (r.key !== openKey) {
      r.key = openKey;
      r.sig = null;
      r.armed = !!openKey;
      // 부모의 초기화 setState 반영 후 한 번 더 렌더해 스냅샷을 잡는다
      setTick((x) => x + 1);
      return;
    }
    if (r.armed) {
      r.sig = sig;
      r.armed = false;
      setTick((x) => x + 1);
    }
  }, [openKey, sig, tick]);
  const r = ref.current;
  if (!openKey || r.key !== openKey || r.sig == null) return false;
  return r.sig !== sig;
}
